import Button from '@/components/atoms/button';
import Typography from '@/components/atoms/typography';
import { localeMapping } from '@/constants/localeMapping';
import { tablet } from '@/constants/screensizes';

import { ArrowDownTrayIcon, EnvelopeIcon } from '@heroicons/react/24/outline';
import { useParams, useRouter } from 'next/navigation';
import React from 'react';

interface ProductAttributes {
  assetsAttributes?: Array<{ name: string; value: string }>;
}

const FeaturesBenefits: React.FC<{ attributes: any }> = ({ attributes }) => {
  const { locale } = useParams();
  const localeString = Array.isArray(locale) ? locale[0] : locale || '';
  const localeKey = localeMapping[localeString];

  const features = attributes['item-attributes']?.find((attribute: { name: string }) => attribute.name === 'features')
  ?.value[localeKey];  
  const router = useRouter();

  const brand = attributes?.brand;
  const brandString = typeof brand === 'string' 
    ? brand 
    : (brand && typeof brand === 'object' && brand.label ? String(brand.label) : '');
  const isLeakSmart = brandString.toLowerCase().includes('leak smart') || brandString.toLowerCase().includes('leaksmart');

  const handleButtonClick = () => {
    router.push(`/${locale}/warranty`);
  };

  return (
    <div className="mt-6 md:mt-[80px]" id="features-benefits">
      <Typography className="features-benefits text-[22px] !font-medium !leading-snug text-[#090909] md:text-[26px]">
      Features and Benefits
      </Typography>
      <div className="grid grid-cols-1 md:grid-cols-1">
        <div className="col-span-2 bg-white">
          <div className="col-span-1 mt-5">
            <ul className="pl-4 list-disc list-inside"> 
              {features &&
                features.replaceAll('- ', '\n').split('\n').filter((s: string) => !!s?.trim()).map((feature: string | undefined, index: number) => {
                  return (
                    <li className={`text-[16px] text-[#333333] font-normal leading-8`} key={index}>
                      {feature}
                    </li>
                  )
                })}
            </ul>
          </div>
          {/* {!isLeakSmart && ( */}
            <Button
              Icon={ArrowDownTrayIcon}
              iconClassName='w-[32px] h-[32px]'
              iconPosition="left"
              variant="secondary"
              className={`broder-Neutral-600 cursor-pointer mt-[56px] justify-center border-2 !px-4 !py-1.5 text-base ${
                window.innerWidth < tablet ? 'w-full' : ''
              }`}
              onClick={handleButtonClick}
            >
              Warranty
            </Button>
          {/* )} */}
        </div>
      </div>
    </div>
  );
};
export default FeaturesBenefits;
